import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../store/authenticationStore'

export const AuthorityRequest = {
  getAuthorityIssueds: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/authority-issueds`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),

  createAuthority: payload =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/authority-issueds`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: payload,
    }),
}
